import React, { useState } from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import { capitalize } from 'utils';

import { ReactComponent as FileIcon } from 'pages/Teachers/StudentDetail/assets/file.svg';
import { ReactComponent as PersonIcon } from 'pages/Teachers/StudentDetail/assets/person.svg';
import SubjectDialog from 'pages/Teachers/StudentDetail/components/SectionSubjectUpdateDialog';

import styles from './styles.module.scss';

const StudentSubtitle = ({
  studentName,
  sectionLabel,
  fullLabel,
  subjectName,
  sectionId,
  refetchSectionDetail
}) => {
  const [isSubjectDialogOpen, setIsSubjectDialogOpen] = useState(false);

  if (!studentName && !sectionLabel) return null;

  return (
    <div className={styles.navSubtitleContainer}>
      {studentName && (
        <div className={styles.navSubtitleGroup}>
          <PersonIcon className={styles.navSubtitleIcon} />
          <span className={styles.studentNameText}>
            {capitalize({ str: studentName })}
          </span>
        </div>
      )}
      {sectionLabel && (
        <div
          className={styles.navSubtitleGroup}
          onClick={() => setIsSubjectDialogOpen(true)}
        >
          <FileIcon className={styles.navSubtitleIcon} />
          <Tooltip title={fullLabel} placement="top">
            <span className={styles.sectionLabelText}>{sectionLabel}</span>
          </Tooltip>
        </div>
      )}
      {isSubjectDialogOpen && (
        <SubjectDialog
          onClose={() => {
            setIsSubjectDialogOpen(false);
          }}
          initialSubject={subjectName}
          sectionId={sectionId}
          onSuccess={() => {
            refetchSectionDetail();
          }}
        />
      )}
    </div>
  );
};

export default StudentSubtitle;
